<template>
  <div :class="modalTheme" style="background: transparent; padding: 0px; height: 100%; width: 100%; overflow: auto">
    <h3 v-if="AreIdsShown">My Work Details {{ modalTheme }}</h3>
    <DxButton v-if="AreIdsShown" icon="refresh" @click="refreshDataGrid" />

    <!-- <div :class="modalTheme">
      <h3>WORK TEST</h3>
      <div :class="userStore.borderClass">
        <h3>WORK TEST</h3>

        <h4>** RECORD SELECTOR</h4>
      </div>
    </div> -->

    <DxDataGrid
      class="patientMeasuresTasksGrid"
      ref="dataGridRef"
      :data-source="props.dataRow.tasks"
      :repaint-changes-only="true"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      :column-auto-width="true"
      :auto-expand-all="false"
      key-expr="id"
      :focused-row-enabled="true"
      :two-way-binding-enabled="true"
      :show-borders="true"
      @row-click="toggleRow1"
      @selection-changed="selectionChanged"
      @initialized="saveGridInstance"
      @row-prepared="onRowPrepared"
      @row-expanding="onRowExpanding"
      @cell-click="onCellClickWD"
      @row-collapsed="onRowCollapsed"
      @row-expanded="onRowExpanded"
    >
      <DxLoadPanel :enabled="true" />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="false" />

      <DxEditing :allow-updating="false" :allow-adding="false" :allow-deleting="false" mode="cell" />

      <DxSelection mode="single" />

      <DxScrolling :use-native="true" mode="infinite" />
      <!-- <DxSelection  v-if="CanDelegate" select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" /> -->

      <!-- <dx-column type="buttons" caption="Status1" data-field="status">
          <dx-button name="save" css-class="my-class" />
          <dx-button name="edit" />
          <dx-button name="delete" />
           Declare and configure custom buttons here
           <div v-if="status === 'Not Addressed'"><h1>NOT</h1></div>
          <dx-button text="Set Status" :on-click="setStatus" icon="/content/images/CM_green.png"></dx-button>
          <dx-button text="Set Status" :on-click="setStatusR" icon="/content/images/CM_red.png"></dx-button>
          <dx-button text="Set Status" :on-click="setStatusY" icon="/content/images/CM_yellow.png"></dx-button>
        </dx-column>
			<img @click="changeStatus()" v-b-popover.hover.top="'Change Status'" src="/content/images/littleglight.png" />-->
      <!-- <dx-column data-field="id" caption="Id" /> -->

      <DxColumn v-if="AreIdsShown" data-field="id" caption="id" />

      <DxColumn data-field="priority" caption="Priority" cell-template="priority-cell" :width="60" />
       <template #priority-cell="{ data }">
        <div class="newStatusHi" style="padding: 0%">
          <div class="justify-content-center align-items-center" style="display: flex; padding: 0%; width: 100%">
            <div>
              <!-- {{ data.text }} -->
              <h6 class="mb-0" v-if="data.text === '0'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (info) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #17a2b8; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Bell icon (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'bell']" size="1x" style="color: white; position: absolute; left: 0.45em; top: 0.45em; font-size: 1.2em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '1'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em; background: MistyRose; border-radius: 0.5em">
                  <!-- Bottom diamond (filled) -->
                  <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation, centered and larger -->
                  <font-awesome-icon :icon="['fas', 'exclamation']" size="lg" style="color: #dc3545; position: absolute; left: 0.55em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top diamond (outline, optional for effect) -->
                  <!-- <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 3" /> -->
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '2'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (danger) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation circle (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" style="color: white; position: absolute; left: 0.17em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
            </div>
          </div>
        </div>
      </template>

      <DxColumn data-field="currentOwner" caption="Current Owner" @mouseenter="toggleOwnerToolTip" @mouseleave="toggleOwnerToolTip" />

      <DxColumn id="orgOwner" data-field="originalOwner" caption="Original Owner" />

      <DxTooltip :visible="IsOriginalOwnerVisible" :close-on-outside-click="false" target="#orgOwner">ExcelRemote IR</DxTooltip>

      <DxColumn data-field="dueDate" caption="Due Date" sort-order="desc" cell-template="formatDueDate" data-type="date" />

      <template #formatDueDate="{ data }">
        <span>{{ useFormatDate(data.text) }}</span>
      </template>
      <!--
			<DxColumn data-field="usrSelectRowId" type="buttons" caption="usrSelectRowId">
				<dx-button :rowId="usrSelectRowId" :on-click="openStatusModel" text="id"></dx-button>
			</DxColumn>-->
      <!--
			<DxColumn data-field="status" caption="Status ORG" cell-template="grid-cell" />
			 <template #grid-cell="{ data }">
				<div style="color:blue">{{ data.cell.text }}</div>
			</template>-->

      <DxColumn data-field="status" caption="Status" cell-template="status-cell" />

      <template #status-cell="{ data }">
        <div class="StatusHi" style="padding: 0%">
          <b-nav pills justified>
            <b-nav-item>{{ data.text }}</b-nav-item>
          </b-nav>
        </div>
        <!-- <b-nav pills justified>
            <b-nav-item to="/Dashboard/Coding/droppedHCC">
              <span style="font-size:12pt;">Dropped HCC Work</span>
            </b-nav-item>
				</b-nav>-->
      </template>

      <DxColumn data-field="taskType" caption="Task Type" />

      <DxColumn data-field="assignment" caption="Action" cell-template="action-cell" />
      <template #action-cell="{ data }">
        <div class="ActionHi" style="padding: 0%">
          <b-nav pills justified>
            <b-nav-item>{{ data.text }}</b-nav-item>
          </b-nav>
        </div>
        <!-- <b-nav pills justified>
            <b-nav-item to="/Dashboard/Coding/droppedHCC">
              <span style="font-size:12pt;">Dropped HCC Work</span>
            </b-nav-item>
				</b-nav>-->
      </template>

      <!-- <DxColumn data-field="workType" caption="Work Type"></DxColumn> -->

      <DxColumn data-field="problem" caption="Subject" />

      <!-- & Master  MASTER   MASTER DETAIL      TASK COMMENTS -->

      <DxMasterDetail :enabled="true" template="myWorkDetail" />

      <!-- // tmp   Template:  PATIENT  TASK  COMMENT  FORM -->
      <template #myWorkDetail="{ data: record }">
        <div :class="modalTheme">
          <!-- <h3>WORK TEST</h3> -->
          <div :class="userStore.borderClass">
            <!-- <h3>WORK TEST</h3> -->

            <!-- <h4>** RECORD SELECTOR</h4> -->

            <!-- {{ modalTheme }} -->
            <b-row style="background-color: transparent; padding: 0px; padding-left: 20px; margin-left: 0px">
              <b-col cols="8" style="padding: 0px; margin-left: 0px">
                <h4 v-if="AreIdsShown">usrSelectRowId {{ usrSelectRowId }}</h4>

                <!-- <h2>this.Id ? personID = {{id}}</h2> -->

                <h3 v-if="AreIdsShown" style="color: red">OVERHAUL RECORD : record</h3>

                <PatientTaskCommentsForm :task-data="record" :rowId="usrSelectRowId" @post-comment="onPostCommentWORK" />
              </b-col>
              <!-- <b-col cols="4"></b-col> -->
              <b-col v-if="record.data.taskRecords.length > 0" cols="4">
                <DxDataGrid
                  :data-source="record.data.taskRecords"
                  :allow-column-resizing="true"
                  :column-auto-width="false"
                  :repaint-changes-only="true"
                  :two-way-binding-enabled="true"
                  :show-borders="true"
                >
                  <DxColumn width="20%" data-field="type" caption="Type" />
                  <DxColumn width="80%" data-field="description" caption="Description" />
                </DxDataGrid>
              </b-col>
            </b-row>
          </div>
          <!-- <h2>DxDataGRid data-source="task.data. YES" usrSelectRowId {{usrSelectRowId}} : Task = {{task.data.id}}</h2>
					<h2>detail Data taskComments : {{task.data.taskComments.length}}</h2>
					<h3 style="background-color:blackcolor:orange">THIS IS NEW GRID</h3>-->
          <!-- <DxDataGrid :data-source="task.data.taskComments" :column-auto-width="true" :repaint-changes-only="true" :two-way-binding-enabled="true" :show-borders="true"></DxDataGrid> -->
        </div>
      </template>

      <!-- & modal  B-MODAL STATUS FORM -->
      <b-modal v-model="showStatusForm" body-class="p-0" size="sm" title="Status Form" hide-footer :content-class="modalTheme" :header-class="modalTheme">
        <b-container fluid style="padding: 0px !important">
          <PatientTaskStatusForm :personId="patientStore.currentPatient.personId" :statusData="patientStore.currentSelectedPatientTask" @put-TaskStatus="putMYWORKTaskStatus"></PatientTaskStatusForm>
        </b-container>
        <!-- <template #modal-footer>
					<div class="w-50">
						<p class="float-left">Modal Footer Content</p>
						<b-button variant="primary" size="sm" class="float-right" @click="show=false">Close</b-button>
					</div>
				</template>-->
      </b-modal>

      <!-- & modal  B-MODAL REASSIGN ACTION FORM -->
      <b-modal v-model="showReAssignForm" body-class="p-0" size="sm" title="ReAssign Form" hide-footer :content-class="modalTheme" :header-class="modalTheme">
        <b-container fluid style="padding: 0px !important">
          <!-- <h2>PatientTasksReAssignForm</h2> -->

          <PatientTasksReAssignForm :statusData="patientStore.currentSelectedPatientTask" @postTaskReAssign="putTaskReAssign"></PatientTasksReAssignForm>
        </b-container>
        <!-- <template #modal-footer>
					<div class="w-50">
						<p class="float-left">Modal Footer Content</p>
						<b-button variant="primary" size="sm" class="float-right" @click="show=false">Close</b-button>
					</div>
				</template>-->
      </b-modal>
    </DxDataGrid>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, reactive } from "vue";
import { toast } from "vue3-toastify";

import { postTaskComment, putTaskStatus, postReAssignWork } from "@/api/discreteDataApi";

import { fetchMyWorkDetails } from "@/api/workListsApi";

// import { storeToRefs } from 'pinia'

import { useFormatDate } from "@/use/formatDate.js";

import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxHeaderFilter,
  DxLoadPanel,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxMasterDetail,
  DxSelection,
  DxScrolling,
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import { usePatientStore } from "@/stores/patientStore";

// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";

import PatientTaskCommentsForm from "@/modules/Patient/PatientTaskCommentsForm.vue";

import PatientTaskStatusForm from "@/modules/Patient/PatientTasksStatusForm.vue";
import PatientTasksReAssignForm from "@/modules/Patient/PatientTasksReAssignForm.vue";

// & ROUTER
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

import BlankForm from "@/modules/Patient/BlankForm.vue";

// ^ DESTRUCTING from A STORE
import { storeToRefs } from "pinia";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STORE  PATIENT
const patientStore = usePatientStore();
// * STORE  WorkList
const workListStore = useStoreWorkList();


// * EMITTER
const emit = defineEmits(["postTaskStatusRefresh"]);

const _name = patientStore.name;
// const { setUserCanEditAlertMessage } = storeToRefs(patientStore);

// const { setCurrentSelectedPatientTask } = storeToRefs(patientStore)

// & PROPS
const props = defineProps({
  dataRow: { Type: Object, Default: () => {} },
  // id: { type: String, Default: () => {} },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const dataGridRef = ref(null);

let workDetailPayload = ref([]);

let bRecords = ref([]);

// // * a computed ref
// const workDetailRecordsLength = computed(() => {
// 	console.log(workDetailRecords.value.length)

// 	const vTest = workDetailRecords.value
// 	console.log('vTest')
// 	console.log(vTest)
//   return vTest.value;
// });

// TODO  a computed ref
// const publishedBooksMessage = computed(() => {
//   console.log("bRecords");
//   console.log(bRecords);
//   return bRecords.value.length > 0 ? "Yes" : "No";
// });

const usrSelectRowId = ref("");

const dataGridInstance = ref(null);

const showModal = ref(false);

const showStatusForm = ref(false);
const showReAssignForm = ref(false);

const currentTask = ref({});

function onRowExpanded(e) {
  // console.clear()
// console.log(" on ROW EXPPPPPPPPPPPPPPPPP");

// console.log("E:");
// console.log(e);

  usrSelectRowId.value = e.key;
// console.log(" 	GET usrSelectRowId on EXPANd:  ", usrSelectRowId.value);
// console.log(" ...	" + usrSelectRowId.value + "		... ");

  // setCurrentTask(e)
}
function onRowCollapsed(e) {
  // // //console.clear()()
// console.log(" 										...	 on Row COLLAPSED		... ");
  this.usrSelectRowId = e.key;
  // // console.log(' ...	MY ROW KEY : 		... ', this.usrSelectRowId)
}
function toggleRow1(e) {
  // if (this.dataGridInstance.isRowExpanded)
  // //console.clear()()

// console.log("toggleRow1 E:");
// console.log(e);
  e.isRowExpanded = !e.isRowExpanded;

// console.log("---------------        toggleRow1 E:  ", e.isRowExpanded);
// console.log(" toggleRow1 ");

// console.log("E");
// console.dir(e);

// console.log("                     THIS IIS THE ROWs data elements  >>>>> ");
// console.dir({ ...e.data });
}

function onCellClickWD(e) {
  // console.clear()
// console.log(" 																						...	 on onCellClick WD		... ");

// console.log("  onCellClickWD   E:");
// console.log(e);
// console.log(e.key);

// console.log(" 										...	 on onCellClick          .. ");
  // this.usrSelectRowId = e.key;
  // console.log("this.usrSelectRowId =:");
  // console.log(this.usrSelectRowId);

  // this.usrSelectRowId.value = e.key;
  // console.log(" 	GET usrSelectRowId on EXPANd:  ", this.usrSelectRowId);
  // console.log(" ...	" + this.usrSelectRowId + "		... ");

// console.log("e.row.isSelected : ", e.row.isSelected);
  if (e.row.isSelected) {
    e.component.clearSelection();
  }

  if (e.column.dataField === "status") {
    // // console.dir(e.row.data)
    this.currentTask = e.row.data;
// console.log("		                              								CURRENT TASK:  	");
// console.log(this.currentTask);
    openStatusModel(e);
  }
  //  else if (e.column.dataField === 'originalOwner') {
  // 	this.modalOrgOwnerName = e.value
  // 	this.showModal1 = !this.showModal
  // } else {
  // // console.log('														FOUND:  ', e.column.dataField)
  // // console.log('																	CELL >>>  THIS = e.value', e.value)
  // }

  if (e.column.dataField === "assignment") {
    // // console.dir(e.row.data)
    this.currentTask = e.row.data;
    // // console.log('										CURRENT TASK:  	', this.currentTask)
    openReAssignModel(e);
  }

// console.log("****************************************************");
  this.currentTask = e.row.data;

  // STORE COMMITs setCurrentSelectedPatientTask
// console.log("	  NEW COMMIT	***			>>>>>>>>>>>>>>>>>>    STORE  		setCurrentSelectedPatientTask	 this.currentTask");
// console.log({ ...this.currentTask });
  //   this.$store.commit("setCurrentSelectedPatientTask", this.currentTask);

// console.log(" PATIENT >>  STR  MUTATION    *** setCurrentPatient ***");
// console.log("         this path just SETs a STORE variable      ");
  patientStore.setCurrentSelectedPatientTask(this.currentTask);

// console.log(patientStore.currentSelectedPatientTask);

  // patientStore.name
  const somePayload = { name: patientStore.name };

  // patientStore.setCurrentPatient(somePayload)
  // patientStore.doAlertFromStore()
  // patientStore.doAlertFromStorepay(somePayload)

  //
  // ? PATCH store ITEM
  // it internally calls `$patch()`:
  // store.$patch({ count: 24 })

  // patientStore.$patch({
  //  currentSelectedPatientTask: this.currentTask,
  //  currentPatientTaskComments: this.currentTask.taskComments,

  // })

  // console.log(' TEST:  access directly     st.XXX.value    currentSelectedPatientTask')
  // patientStore.currentSelectedPatientTask = this.currentTask

  // console.log( patientStore.currentSelectedPatientTask)
  // console.log('_____PATCHING________________________________________________________________________________________________')

  // setCurrentSelectedPatientTask
  // setCurrentPatientDXCodes

  // STORE COMMITs setCurrentPatientTasksComments
  // console.log(				'		***			>>>>>>>>>>>>>>>>>>    STORE  		setCurrentPatientTasksComments	 this.currentTask.taskComments'			)
  // console.dir(this.currentTask.taskComments)

  // TODO TASK COMMENTS - CHECK FORM DeCOMPILE
// console.log("RUN  commit setCurrentPatientTasksComments");
  // this.$store.commit("setCurrentPatientTasksComments", this.currentTask.taskComments);
  patientStore.setCurrentPatientTasksComments(this.currentTask.taskComments);

  // ? TO PATCH  in
  //   state.currentSelectedPatientTask.taskComments = payload

  // // * BIND NEW - state.currentPatient.tasks.taskComment

  // // & NEW
  // state.currentPatient.tasks.taskComments = payload
  // state.currentPatientTaskComments = payload

  // console.log('	 check >>>  	this.currentTask.taskComments')
  // console.dir(this.currentTask.taskComments)
}

function selectionChanged(e) {
  // //console.clear()()
// console.log("			MyWorkDetails > selectionChange()");
// console.dir(e);
// console.log("________________________________");

  e.component.collapseAll(-1);
  e.component.expandRow(e.currentSelectedRowKeys[0]);
}

function saveGridInstance(e) {
// console.log("    SAVING    grid INSTANCE .>>> > ");
// console.dir(e);
// console.log("________________________________");

  this.dataGridInstance = e.component;
}
function onRowPrepared(e) {
  // console.clear()
  // console.log("				!!!  my work detaila >>>			onRowPrepared						______________________rowElement..e......");

  // console.log('_________________________________')
  // console.log(' start  E: ')

  // console.dir(e)
  // console.log(e.data)
  const rowElement = e.rowElement;
  // console.dir(rowElement)

  rowElement.style.cursor = "pointer";
  const record = e.data;

  // console.log('record........')

  // console.dir(record)
  // console.log('RecordID: ' + record.id)

  if (!record) return; // this is probably a header or footer row and thus doesn't have the data property
  if (record.taskType === "Not Validated by Clinician") {
    rowElement.style.backgroundColor = "#dcf1de";
    // rowElement.style.color = '#dcf1de'
    //rowElement.cells[5].bgColor = 'darkgoldenrod'
    //rowElement.style.fontWeight = 900
  } else if (record.taskType === "Not Validated by Coder") {
    // rowElement.style.backgroundColor = '#e7caca'
    // rowElement.style.color = 'yellow'
    rowElement.style.fontWeight = 900;
    //rowElement.cells[5].bgColor ='#e7caca'
    // & ADD CLASS to ROW
    // rowElement.classList.add('testClass')
  } else {
    rowElement.style.backgroundColor = "";
    rowElement.style.color = "";
  }
}
async function onRowExpanding(e) {
  // //console.clear()()
// console.log("   	   	endOf												DASH   REC SELECTOR  onRowExpanding :  collapseAll");
  e.component.collapseAll(-1);

// console.log("E: ");
// console.dir(e);
}
function openStatusModel(e) {
  // Execute your command here
  // // console.log('open Status Modal')
  // toastrSuccess(' SElected Row ' + e.selectedRowsData)
  showStatusForm.value = !showStatusForm.value;
}
function openReAssignModel(e) {
  showReAssignForm.value = !showReAssignForm.value;
}

async function onPostCommentWORK(comment) {
  //console.clear()()
// console.log("				 My WORk Details ON POST  COMMENT: NEW ");
// console.log("			>>>>>>>>>>>>>			ON POST COMMENT : ");
// console.dir(comment);

// console.log(comment.usrSelectRowId);
// console.log(comment.text);
// console.log(comment.patientId);

  // //todo ADD POST TASK COMMENT REPOSNE = TASK []
  const response = await postTaskComment(comment.usrSelectRowId, comment.patientId, comment.text);

  //console.clear()()
// console.log("RESponse  PAYLOAD : IS TASK COMMENTS ");
// console.dir(response.payload);

  // TODO TASK COMMENTS - CHECK FORM DeCOMPILE
// console.log(".........................RUN  commit setCurrentPatientTasksComments");
  // this.$store.commit('setCurrentPatientTasksComments', response.payload)

  patientStore.setCurrentPatientTasksComments(response.payload);

  // console.log('	 check >>>  	this.currentTask.taskComments')
  // console.dir(this.currentTask.taskComments)

  // console.log('	REMOVED >> !@  DIG THIS     		>>>>>>>> getRecords >>>>>							this.id : ' + this.id)
// console.log(" LINE 582 > 589");
  // const resPOST = await this.getRecords(this.id);
  // this.records = resPOST.payload;
  // // console.log('this.records ==== TASKS ')
  // // console.dir(this.records)
  // // console.log(this.records.length)
  // // STORE  STORE -->
  // // console.log('>>> SETTING curr Patient Tasks ..........................')
  // this.setCurrentPatientTasks(this.records);

  //	this.refreshDataGrid()

  //	this.$router.go(this.$router.currentRoute)

  // toast.success("Hello");
  // toast.info("World");
  // toast.error("Error");

  if (!response.ok) {
    toast.error("There was a problem submitting the COMMENT.  Please try again or contact technical support.");
    return;
  }
  toast.success("Successfully posted new Task Comment");
  showModal.value = false;
}
async function putMYWORKTaskStatus(payload) {
  // console.clear();
// console.log("putMYWORKTaskStatus     payload");
// console.log(payload);

  showStatusForm.value = !showStatusForm.value;

  const response = await putTaskStatus(payload.Id, payload.PersonId, payload.Comment, payload.Status);
// console.log("RESponse  PAYLOAD : task comments");
// console.log(response.payload);
// console.log("   STORE SETTING RUN  commit setCurrentPatientTasksComments");

  patientStore.setCurrentPatientTasksComments(response.payload);

  if (!response.ok) {
    toast.error("There was a problem submitting the COMMENT.  Please try again or contact technical support.");
    return;
  }

  if (response.ok) {
    toast.success("Successfully posted new Task Comment");
    // this.regetTasks()
    const currentWidgetId = workListStore.currentSelectedWorkSummaryWidget.id;
// console.log("                     currentWidgetId : ");
// console.log(currentWidgetId);
// console.log("                             workListStore.getWidgetSummaryListFromAPI()                ");
    const list = await workListStore.getWidgetSummaryListFromAPI();
  }
  showModal.value = false;

  emit("postTaskStatusRefresh", true);
// console.log(" PAYLOAD was await putTaskStatus  EMITTINIG postTaskStatusRefresh ");
}
async function putTaskReAssign(comment) {
  ////console.clear()()
// console.log("			My 	WORK 	DETAILS :   	putTaskReAssign      	comment      putTaskReAssign COMMENT: NEW ");

// console.log("comment");
// console.dir(comment);

  showReAssignForm.value = !showReAssignForm.value;
// console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");

  const response = await postReAssignWork(comment.id, comment.text, comment.recipients);

// console.log("RESP>>>>  ?????????? EMPTY");

// console.dir(response);

  if (!response.ok) {
    toast.error("There was a problem submitting the COMMENT.  Please try again or contact technical support.");
  }

  if (response.ok) {
    toast.success("Successfully posted new Task Comment");
    toast.success(" OFF    NEW ROUTER GO                    ROUTER vue3 COMP   TESTING  >>>>>>>>>>>>>>>>>>>>>>>>>>>> ");

    // // this.$router.go(this.$router.currentRoute)
    // router.go(router.currentRoute.value.path);

// console.log("        &&&&   REDESIGN for  ReGet  WidgetSummaryList Work  DATA");
    const currentWidgetId = workListStore.currentSelectedWorkSummaryWidget.id;
        // console.log("                     currentWidgetId : ");
        // console.log(currentWidgetId);
        // console.log("                             workListStore.getWidgetSummaryListFromAPI()                ");
    // const list = await workListStore.getWidgetSummaryListFromAPI();
    await workListStore.getWidgetSummaryListFromAPI();
  }
  showModal.value = false;
}

function refreshDataGrid() {
  // console.clear();
// console.log("              refreshDataGrid");
  // const dataGrid = dataGridRefKey.instance;
  const dataGrid = dataGridRef.value.instance;
// console.log("                                         dataGrid");
// console.log(dataGrid);
  dataGrid
    .refresh()
    .then(function () {
      // ...
// console.log(" grid refresh");
      const dSource = dataGrid.getDataSource().items();
// console.log(" grid : DATASOURCE");
// console.log(dSource);
// console.log(" dataGrid.getVisibleRows() ");
// console.log(dataGrid.getVisibleRows());
// console.log(" dataGrid.getSelectedRowsData() ");
// console.log(dataGrid.getSelectedRowsData());
    })
    .catch(function (error) {
// console.log("ERROR >>>>");
// console.log(error);
    });
}
onMounted(() => {
  // console.clear();
// console.log("onMounted() :       MyWOrkDetails  >>>>");

  bRecords = patientStore.currentPatient.tasks;
// console.log(" Get Current Patient Tasks  from Store ");
// console.log("bRecords");
// console.dir({ ...bRecords });

// console.log("props : ");
// console.log(props);
// console.log(" prop   dataRow ");
// console.log(props.dataRow);
});
</script>

<style lang="scss" scoped>
.right-side {
  position: absolute;
  right: 1px;
  top: 6px;
  background-color: darkblue;
}
.bg-light {
  background-color: #ffb300 !important;
}
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 0rem;
}
.StatusHi {
  // background-color: #05cdec53;
  // font-size: 14pt;
  // color: #eaf7ebb7;
}
.ActionHi {
  //background-color: #05cdec53;
  // font-size: 14pt;
  // color: #eaf7ebb7;
}
.nav-link {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #eaf7ebc8;
  background-color: #43997848;
  border-color: #43997848 #43997848 #43997848;
  border-radius: 5px;
  font-weight: bold;
}
.nav-link:hover,
.nav-link:focus {
  // text-decoration: underline solid cyan;
  background-color: #43756c; //#0ca2d4be;
  color: cyan;
  font-weight: bolder;
}
.nav-pills .nav-link.active {
  background-color: #018955c4;
  color: #eaf7ebc8;
  font-weight: bold;
}

.nav-pills .nav-link {
  border-radius: 5px;
}
.modalCart {
  background-color: rgb(255, 0, 212);
}
// .modal-body > div {
// 	position: absolute !important;
// 	top: 0px !important;
// 	left: 0px !important;
// 	background-color: rgba(106, 0, 255, 0.586) !important;
// 	color: rgb(4, 255, 0);
// 	padding: 0% !important;
// }
:deep(.modal-body) {
  background-color: rgb(255, 0, 212);
  padding: 0%;
}
.text-center {
  background-color: darkblue;
}
.child-class {
  background-color: rgb(255, 166, 0);
}
:global(.modal-body) {
  background-color: transparent; // rgb(0, 255, 145);
  padding: 0%;
}
a.nav-link {
  display: block;
  // background-color: #bcb91a;
  padding: 0%;
}
</style>
